module.exports = {
    controller: searchTextsGermanyController,
    templateUrl: 'search/components/pages/search-texts-germany.html'
};

searchTextsGermanyController.$inject = [
    '$analytics', 
    '$location', 
    'notificationsService', 
    'dataContext', 
    'language', 
    'config', 
    'applicationStateService',
];

function searchTextsGermanyController(
    $analytics, 
    $location, 
    notificationsService, 
    dataContext, 
    language, 
    config, 
    state
) {

    var vm = {
        $onInit: attached,
        $onDestroy: detached,
        isLoading: false,
        query: {
            QueryString: ''
        },
        results: [],
        scrollToDocument: scrollToDocument,
        search: search
    };

    return vm;

    function attached() {
        vm.query.QueryString = $location.search().query;
        $analytics.pageTrack('/texts-germany-search');
        loadSearch();
        notificationsService.subscribe('filter_date_changed', loadSearch);
    }

    function detached() {
        notificationsService.unsubscribe('filter_date_changed', loadSearch);
    }

    function search(query) {
        $location.path('/search/texts/germany').search(query);
    }

    function scrollToDocument(eztDocument) {
        document
            .querySelector('.' + eztDocument.HtmlClassName)
            .scrollIntoView({ behavior: 'smooth', block: 'start' });
    }


    function loadSearch() {
        var url = config.apiHosts.dtv + '/ezt/texts/search' +
            '?lang=' + language.get() +
            '&q=' + vm.query.QueryString +
            '&date=' + state.filter.date;
        if (vm.query.QueryString && vm.query.QueryString.length > 1) {
            vm.isLoading = true;
            dataContext.get(url)
                .then(function (data) {
                    vm.isLoading = false;
                    vm.result = data;
                });
        }
    }
}